export const getStyles = (tabWidth: string, hasBanner: boolean) => {
  const styles = {
    root: {
      position: "fixed",
      top: hasBanner ? 100 : 60,
      bottom: 0,
      right: tabWidth,
      zIndex: 100,
    },
    active: {
      borderRight: `3px solid`,
    },
    icon: {
      fontSize: 24,
      p: 2,
      width: "57px", // border right + width = 60px
    },
  };
  return styles;
};
